/**
 * OrderNotificationService
 * Service for OrderNotification entity operations
 * Route: api/ordernotifications
 * Controller: OrderNotificationsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderNotificationService
 * Handles order notification CRUD operations
 * Maps to /api/ordernotifications endpoint
 */
export class OrderNotificationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderNotificationService.DEFAULT_SERVICE_PATH,
            basePath: OrderNotificationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== QUERY BY ORDER ====================
    /**
     * Get order notifications by order ID
     * GET /api/ordernotifications?orderId={orderId}
     */
    async getByOrderId(orderId) {
        const response = await this.getByOrderIdRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get order notifications by order ID (raw)
     */
    getByOrderIdRaw(orderId) {
        const url = this.buildUrl(`?orderId=${orderId}`);
        return this.http.get(url);
    }
    // ==================== QUERY BY PROCESSED STATUS ====================
    /**
     * Get unprocessed notifications
     * GET /api/ordernotifications?isProcessed=false
     */
    async getUnprocessed() {
        const response = await this.getUnprocessedRaw();
        return response.data ?? [];
    }
    /**
     * Get unprocessed notifications (raw)
     */
    getUnprocessedRaw() {
        const url = this.buildUrl('?isProcessed=false');
        return this.http.get(url);
    }
    /**
     * Get processed notifications
     * GET /api/ordernotifications?isProcessed=true
     */
    async getProcessed() {
        const response = await this.getProcessedRaw();
        return response.data ?? [];
    }
    /**
     * Get processed notifications (raw)
     */
    getProcessedRaw() {
        const url = this.buildUrl('?isProcessed=true');
        return this.http.get(url);
    }
}
OrderNotificationService.DEFAULT_SERVICE_PATH = 'orders';
OrderNotificationService.BASE_PATH = 'api/ordernotifications';
//# sourceMappingURL=OrderNotificationService.js.map